export const ANALYTICS_CONSTS = {
  moduleName: 'epb-analytics',

  getters: {
    data: 'data',
    selectedId: 'selectedId'
  },
  actions: {
    loadDistData: 'loadDistData',
    loadPivotData: 'loadPivotData',
    loadSessionsData: 'loadSessionsData',
    loadQueriesData: 'loadQueriesData',
    loadRelatedData: 'loadRelatedData',
    loadSearchData: 'loadSearchData',

    setSelectedId: 'setSelectedId',

    clearData: 'clearData',

    fetchStatsReport: 'fetchStatsReport'
  },
  mutations: {
    setDistData: 'setDistData',
    setPivotData: 'setPivotData',
    setSessionsData: 'setSessionsData',
    setQueriesData: 'setQueriesData',
    setRelatedData: 'setRelatedData',
    setSearchData: 'setSearchData',

    setSelectedId: 'setSelectedId',

    clearData: 'clearData'
  }

};
